import { createAction } from '@reduxjs/toolkit';

/** An action that is dispatched when the dark mode toggle preference changes. */
const setTheme = createAction<string>('SET_THEME');
/** An action that is dispatched when the metric toggle preference changes. */
const setIsMetric = createAction<boolean>('SET_IS_METRIC');

export const profilePreferenceActions = {
  setTheme,
  setIsMetric,
};
